import { OrderStatus } from '@restaurant/types';
import { PaymentMethod } from '../Payment';
import { OrderDelivery } from '@restaurant/api';

export { OrderStatus };

export enum OrderType {
  DineIn = 'dine-in',
  Takeaway = 'takeaway',
}

export type Order = {
  id: string | null;
  type: string | null;
  tableNo: number | null;
  customerName: string | null;
  delivery: OrderDelivery | null;
};

export type OrderItem = {
  id: number;
  type: string | null;
  tableNo: number | null;
  customerName: string | null;
  delivery: OrderDelivery;
  totalPrice: number;
  status: OrderStatus;
  dateCreated: number;
  dateUpdated: number;
};

export type OrderDetail = {
  id: string;
  type: string;
  tableNo: number;
  customerName: string;
  status: OrderStatus;
  dateCreated: number;
  dateUpdated: number;
  delivery: OrderDelivery;
  batches: OrderDetailItem[][];
  paymentMethod: string;
  paymentTime: number;

  subtotalPrice: number;
  tax: OrderTax | null;
  totalPrice: number;

  payment: {
    paymentTime: number;
    paymentMethod: PaymentMethod;
    paymentAmount: number;
    roundingAmount: number;
  };
};

export type OrderDetailItem = {
  menuId: number;
  name: string;
  quantity: number;
  totalPrice: number;
  addOns?: {
    menuId: number;
    name: string;
    quantity: number;
    totalPrice: number;
  }[];
  notes: string;
  isChecked: boolean;
};

export type VoidItem = {
  quantity: number;
  addOns: number[];
};

export type OrderTax = {
  taxType: string;
  rate: number;
  amount: number;
  isApplied: boolean;
};
